export const AudioQueryKey = {
    audioOfTheDay: () => ['audio-of-the-day'],
    audioSuggestions: (username: string, slug: string) => ['audio', 'suggestions', username, slug],
    authorAllAudios: (username: string) => ['author', username, 'all-audios'],
    userPaginatedAudios: (sort: string) => ['user', 'paginated-audios', sort],
    authorPaginatedAudios: (username: string, sort: string) => [
        'author',
        username,
        'paginated-audios',
        sort,
    ],
    authorAudioPages: (username: string) => ['author', username, 'paginated-audios'],
    authorAudioPage: (username: string, sort: string, page: number) => [
        'author',
        username,
        'paginated-audios',
        sort,
        page,
    ],
    audiosByIds: (audioIds: string[]) => ['audios', audioIds],
    tagsSuggestion: (query: string) => ['tags', 'suggestions', query],
    sourceTranscodings: (sourceId: string) => ['source', sourceId, 'transcodings'],
    hasAudacityAudios: () => ['has-audacity-audios'],
    hasOwnAudio: (userId: number) => ['user', userId, 'has-own-audio'],
}
